import { render, staticRenderFns } from "./ServiceFormModal.vue?vue&type=template&id=ea068104"
import script from "./ServiceFormModal.vue?vue&type=script&lang=js"
export * from "./ServiceFormModal.vue?vue&type=script&lang=js"
import style0 from "./ServiceFormModal.vue?vue&type=style&index=0&id=ea068104&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea068104')) {
      api.createRecord('ea068104', component.options)
    } else {
      api.reload('ea068104', component.options)
    }
    module.hot.accept("./ServiceFormModal.vue?vue&type=template&id=ea068104", function () {
      api.rerender('ea068104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/modal/ServiceFormModal.vue"
export default component.exports